import angular from 'angular';
import ToastSerivce from './toast.service';
import AuthSerivce from './auth.service';
import HttpInterceptor from './http-interceptor';

let servicesModule = angular.module('app.services', [])

.service('Auth', AuthSerivce)
.service('Toast', ToastSerivce)
.factory('HttpInterceptor', HttpInterceptor)

.run((Auth) => {
	"ngInject";

	Auth.init();
})

.name;

export default servicesModule;



// WEBPACK FOOTER //
// ./client/app/common/services/services.js